// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PayCircleFilledSvg from "@ant-design/icons-svg/es/asn/PayCircleFilled";
import AntdIcon from '../components/AntdIcon';

var PayCircleFilled = function PayCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PayCircleFilledSvg
  }));
};

PayCircleFilled.displayName = 'PayCircleFilled';
export default React.forwardRef(PayCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PayCircleFilled.js
// module id = 1547
// module chunks = 0